/* eslint-disable react/prop-types */
import React from 'react';
import {
  ZCDTooltip,
  ZCDIcon,
  ZCDIconColor,
  TooltipPlace,
  ZCDSwitch,
  ZCDFlex,
} from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { TopicAnalysisStatus } from '../../../enum';
import { AnnounceIcon } from './AnnounceIcon';

function TopicAnalysisErrorStates({ status, isReportBuilder, tags }) {
  const { t } = useTranslation();

  return (
    <ZCDSwitch>
      <ZCDSwitch.Case condition={status === TopicAnalysisStatus.NEVER}>
        <div className={classNames('engage-topic-results-none')} data-testid="topic-analysis-never">
          <div className={classNames('engage-topic-results-none-icon')}>
            <AnnounceIcon />
          </div>
          <div className={classNames('engage-topic-results-none-msg')}>
            <h3>
              <strong>{t('topicAnalysis.errorEngagementNeverHead')}</strong>
            </h3>
            {!isReportBuilder && tags?.length && (
              <div
                className={classNames('engage-topic-results-none-msg-body')}
                dangerouslySetInnerHTML={{
                  __html: t('topicAnalysis.errorEngagementNeverBody', { tags: tags.join(', ') }),
                }}
              />
            )}
            {!isReportBuilder && !tags?.length && (
              <div
                className={classNames('engage-topic-results-none-msg-body')}
                dangerouslySetInnerHTML={{
                  __html: t('topicAnalysis.errorEngagementNeverBodyNoTag'),
                }}
              />
            )}
          </div>
        </div>
      </ZCDSwitch.Case>
      <ZCDSwitch.Case condition={status === TopicAnalysisStatus.ENGAGEMENT_PRE_OPEN}>
        <div
          className={classNames('engage-topic-results-none')}
          data-testid="topic-analysis-preopen"
        >
          <div className={classNames('engage-topic-results-none-icon')}>
            <ZCDIcon name="large-empty-state-publishing" />
          </div>
          <div className={classNames('engage-topic-results-none-msg')}>
            <h3>
              <strong>{t('topicAnalysis.errorEngagementOpenPreHead')}</strong>
            </h3>
            <div className={classNames('engage-topic-results-none-msg-body')}>
              {t('topicAnalysis.errorEngagementOpenBody')}
            </div>
          </div>
        </div>
      </ZCDSwitch.Case>
      <ZCDSwitch.Case condition={status === TopicAnalysisStatus.ENGAGEMENT_OPEN}>
        <div
          className={classNames('engage-topic-results-none', 'engage-topic-report-builder')}
          data-testid="topic-analysis-open"
        >
          <div className={classNames('engage-topic-results-none-icon')}>
            <ZCDIcon name="large-empty-state-publishing" />
          </div>
          <div className={classNames('engage-topic-results-none-msg')}>
            <h3>
              <strong>{t('topicAnalysis.errorEngagementOpenHead')}</strong>
            </h3>
            <div className={classNames('engage-topic-results-none-msg-body')}>
              {t('topicAnalysis.errorEngagementOpenBody')}
            </div>
          </div>
        </div>
      </ZCDSwitch.Case>
      <ZCDSwitch.Case condition={status === TopicAnalysisStatus.PENDING}>
        <div
          className={classNames('engage-topic-results-none', 'engage-topic-report-builder')}
          data-testid="topic-analysis-pending"
        >
          <div className={classNames('engage-topic-results-none-icon')}>
            <ZCDIcon name="med-magnifying-glass" />
          </div>
          <div className={classNames('engage-topic-results-none-msg')}>
            <h3>
              <strong>{t('topicAnalysis.errorPendingAnalysisHead')}</strong>
            </h3>
          </div>
        </div>
      </ZCDSwitch.Case>
      <ZCDSwitch.Case condition={status === TopicAnalysisStatus.EMPTY}>
        <div
          className={classNames('engage-topic-results-none', 'engage-topic-report-builder')}
          data-testid="topic-analysis-empty"
        >
          <div className={classNames('engage-topic-results-none-icon')}>
            <ZCDIcon name="large-empty-state-report" />
          </div>
          <div className={classNames('engage-topic-results-none-msg')}>
            {!isReportBuilder && (
              <h3>
                <strong>{t('topicAnalysis.errorEmptyHead')}</strong>
              </h3>
            )}
            {isReportBuilder && (
              <h3>
                <strong>{t('topicAnalysis.errorEmptyHeadReportBuilder')}</strong>
              </h3>
            )}
            {!isReportBuilder && (
              <ZCDFlex
                className={classNames('engage-topic-results-none-reason')}
                justifyContent="flex-start"
              >
                {t('topicAnalysis.errorEmptyBody')}{' '}
                <ZCDTooltip
                  text={
                    <div className={classNames('engage-topic-results-none-reason-tooltip')}>
                      <h5>{t('topicAnalysis.errorEmptyTooltip')}</h5>
                      <ul>
                        <li>{t('topicAnalysis.errorEmptyTooltip1')}</li>
                        <li>{t('topicAnalysis.errorEmptyTooltip2')}</li>
                        <li>{t('topicAnalysis.errorEmptyTooltip3')}</li>
                        <li>{t('topicAnalysis.errorEmptyTooltip4')}</li>
                      </ul>
                    </div>
                  }
                  place={TooltipPlace.RIGHT}
                >
                  <ZCDIcon name="info" color={ZCDIconColor.BLUE} />
                </ZCDTooltip>
              </ZCDFlex>
            )}
          </div>
        </div>
      </ZCDSwitch.Case>
      <ZCDSwitch.Default>
        <span />
      </ZCDSwitch.Default>
    </ZCDSwitch>
  );
}

export default TopicAnalysisErrorStates;
